import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Subscription } from 'rxjs';
import * as MobileDetect from 'mobile-detect';

import { Chat, CimaCore, CimaToken, CimaUrl, Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';
import { ContactModal } from './modal';
import { StoreAction } from 'store/actions';

import { CallbackTime } from 'store/callback/models';
import { CmsContactBar } from 'store/cms/models';
import { XmVhtModal } from './vht/vht';

@Component({
    selector: 'xm-contact-bar',
    styleUrls: ['./contact-bar.scss'],
    templateUrl: './contact-bar.html',
    standalone: false
})
export class XmContactBarComponent implements OnInit, OnDestroy {
    private static MAX_WAIT_TIME: number = 2;

    public vhtAllowed: boolean = false;
    public pageData: CmsContactBarData;
    public callInstructions: string;
    public chatIcon: MediaImageOptions;

    public isMobile: boolean;

    public cimaToken: CimaToken;

    private cimaCore: CimaCore;
    private cimaUrl: CimaUrl;
    private modalSubscription: Subscription;
    private subscriptions: Subscription[] = [];
    private chat: Chat;
    private contactModal: ContactModal;
    private state: StateService;
    private xmStore: XmStore;
    private mobileDetect: MobileDetect = new MobileDetect(navigator.userAgent);

    constructor(cimaUrl: CimaUrl, cimaCore: CimaCore, cimaToken: CimaToken, chat: Chat, contactModal: ContactModal, state: StateService, xmStore: XmStore) {
        Object.assign(this, { cimaUrl, cimaCore, cimaToken, chat, contactModal, state, xmStore });
    }

    public ngOnInit(): void {
        this.isMobile = Boolean(this.mobileDetect.mobile());
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsContactBar>(CmsContactBar), (response: CmsContactBar) => {
            this.pageData = this.isBusinessUser ? response.commerical : response.residential;

            if (!this.isBusinessUser) {
                this.chatIcon = {
                    mobile: Cloudinary.generateMediaFromCms(this.pageData.chat.icon)
                };

                this.determineCallInstruction();
            }

        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    public loginRequired(): void {
        this.cimaUrl.redirectToLogin({ state: this.state.current.name, params: this.state.current.params || {} });
    }

    public openVhtModal(): void {
        this.modalSubscription = this.contactModal.open<CallbackModalData>(XmVhtModal, Util.cloneProperties(this.pageData.modal)).subscribe((response: ModalResponse) => {
            this.modalSubscription.unsubscribe();
            if (response.data) {
                this.callInstructions = this.pageData.call.callbackText;
            }
        });

        this.subscriptions.push(this.modalSubscription);
    }

    public get isBusinessUser(): boolean {
        return this.cimaCore && this.cimaCore.isBusinessUser;
    }

    public openChat(): void {
        this.chat.openChat();
    }

    private determineCallInstruction(): void {
        if (this.cimaToken.isLoggedIn && this.pageData.call) {
            XmStoreUtil.defaultCatch(this.xmStore.queryPromise<CallbackTime>(StoreAction.GET_CALLBACK_TIME, CallbackTime).then((response: CallbackTime) => {
                this.vhtAllowed = response.estimatedWaitTimeMins >= XmContactBarComponent.MAX_WAIT_TIME;
                this.callInstructions = this.pageData.call.callbackText;
            }));
        }
    }
}
